import { render, staticRenderFns } from "./CorporationsForm.vue?vue&type=template&id=4691eac1&scoped=true"
import script from "./CorporationsForm.vue?vue&type=script&lang=js"
export * from "./CorporationsForm.vue?vue&type=script&lang=js"
import style0 from "./CorporationsForm.vue?vue&type=style&index=0&id=4691eac1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4691eac1",
  null
  
)

export default component.exports